import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=622fce1d&scoped=true"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=622fce1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622fce1d",
  null
  
)

export default component.exports